import { Component, Injectable, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { LogsService } from './logs.service';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { IOption } from 'ng-select';
import { ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { EvsProductService } from '../../../../common/services/EvsProduct.service';
import { StampStatisticsService } from '../statistics/StampStatistics.service';
import { ImageService } from '../../../imageService';
import { ToastrService } from 'ngx-toastr';
import { ExportService } from '../../../../common/services/Export.service';
import { ModalDirective, BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalCancelStampComponent } from '../../qrcode/popup/modalCancelStamp.component';

import { TranslateService } from '@ngx-translate/core';
import { BatchService } from '../../qrcode/batchstamp/batch.service';
import { saveAs } from 'file-saver';

declare var $: any;
var that;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'log_scan',
  templateUrl: './log-scan-list-detail.template.html',
  styleUrls: ['./log-scan.component.css'],
  providers: [EvsProductService, StampStatisticsService, BatchService],
})
@Injectable()
export class LogScanComponent implements OnInit {
  @ViewChild('filterProducts') filterProducts
  page_title: string = 'Lịch sử quét tem';
  no_image = 'assets/images/no_product.gif';
  activeTab: any = 1;

  warningList: any = [];
  warningFilter: any = {};
  isChongia: boolean = true;
  totalWarningPage: number = 0;
  warningPage_Size: number = 10;
  warningCurrentPage: number = 1;
  totalWarningRow: number = 0;
  warningMath = Math;
  messageExportWarning = '';

  //config service
  code_chonggia = 1;
  code_baohanh = 2;
  code_tranhang = 3;
  code_dinhdanh = 5;

  public current_filter: any = {};
  public message: { content: string; alert_type: string } = null;
  public list_items: any = [];
  has_list: boolean = true;
  public item_detail: any;
  public item_detail_loyalty: any;
  public item_active: number = 0;
  loadingDetail: boolean = false;

  list_responses: Array<IOption> = [
    { value: 'active', label: 'Xác thực' },
    { value: 'warning', label: 'Cảnh báo' },
  ];
  list_types: Array<IOption> = [
    { value: 'qrm', label: 'Quét mã hở' },
    { value: 'qri', label: 'Quét mã phủ cào' },
    { value: 'sms', label: 'Nhắn tin sms' },
  ];

  Infinity = Infinity;

  // list_cities:any={};
  list_cities_filter: Array<IOption> = [];
  list_products: Array<IOption> = [];
  list_district_by_city: Array<IOption> = [];
  has_list_districts: boolean = false;
  listBatchs: Array<IOption> = [];
  types: any = [
    {
      value: 1,
      label: 'Vượt quá số lần quét',
      key: 'VUOT_QUA_SO_LAN_QUET'
    },
    {
      value: 3,
      label: 'Cảnh báo doanh nghiệp',
      key: 'CANH_BAO_DOANH_NGHIEP'
    },
  ];
  public FormFilterLogsChongGia: FormGroup;

  pager: any;
  currentPage: number = 1;
  page_size: number = 10;
  totalRow: number = 0;
  isSorting: any = {};
  overview = {
    verify_turn: 0,
    stamps_verify: 0,
    warning_verify: 0,
    warning_stamps: 0,
  };
  waitPage: boolean = false;
  showMoreFilter: boolean = true;
  /***Tuanba:17-11-2022: Thay api xuất báo cáo **/
  public messageExport = '';
  productId: any = null;
  modalRefLocation: BsModalRef;
  serialLocation: string = '';
  locationScan: any = [];
  zoom: number = 6;
  modalRef: BsModalRef;

  constructor(
    private logsService: LogsService,
    private addressService: EvsAddressService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private productService: EvsProductService,
    private stampStatistic: StampStatisticsService,
    private imageService: ImageService,
    private toastr: ToastrService,
    private exportService: ExportService,
    private translate: TranslateService,
    private batchService: BatchService,
    private modalService: BsModalService
  ) {
    that = this;
    this.FormFilterLogsChongGia = fb.group({
      response: [null],
      scan_time_ranger: [null],
      type: [null],
      serial: [null],
      city_id: [null],
      district_id: [null],
      product_id: [null],
    });
    this.item_detail = undefined;

    this.translate.onLangChange.subscribe(() => {
      this.updateTranslations();
    });
    this.translate.get('LICH_SU_QUET_TEM').subscribe((res: string) => {
      this.page_title = res;
      this.updateTranslations();
    });
  }

  selectTab(tab: number) {
    this.activeTab = tab;
    if (this.activeTab === 3) {
      setTimeout(() => {
        const startDate = moment().subtract(2, 'months').startOf('month').toDate();
        const endDate = moment().endOf('month').toDate();
        this.warningFilter.time = [startDate, endDate];
        this.resetWarning();
      }, 50);
    }
  }

  updateTranslations() {
    this.translate.get([
      'LICH_SU_QUET_TEM',
      'XAC_THUC',
      'CANH_BAO',
      'QUET_MA_HO',
      'QUET_MA_PHU_CAO',
      'NHAN_TIN_SMS',
      'SAN_PHAM',
      'TRANG_THAI_QUET',
      'KIEU_QUET',
      'THANH_PHO',
      'QUAN_HUYEN'
    ]).subscribe(translations => {
      this.page_title = translations['LICH_SU_QUET_TEM'];
      this.list_responses = [
        { value: 'active', label: translations['XAC_THUC'] },
        { value: 'warning', label: translations['CANH_BAO'] },
      ];
      this.list_types = [
        { value: 'qrm', label: translations['QUET_MA_HO'] },
        { value: 'qri', label: translations['QUET_MA_PHU_CAO'] },
        { value: 'sms', label: translations['NHAN_TIN_SMS'] },
      ];

      setTimeout(() => {
        if ($('#product_id').length) {
          $('#product_id').select2({ placeholder: translations['SAN_PHAM'], allowClear: false });
        }
        if ($('#response').length) {
          $('#response').select2({
            placeholder: translations['TRANG_THAI_QUET'],
            allowClear: false,
            minimumResultsForSearch: -1,
          });
        }
        if ($('#type').length) {
          $('#type').select2({
            placeholder: translations['KIEU_QUET'],
            allowClear: false,
            minimumResultsForSearch: -1,
          });
        }
        if ($('#city_id').length) {
          $('#city_id').select2({ placeholder: translations['THANH_PHO'], allowClear: false });
        }
        if ($('#district_id').length) {
          $('#district_id').select2({ placeholder: translations['QUAN_HUYEN'], allowClear: false });
        }
        if ($('#warning_batch_id').length) {
          $('#warning_batch_id').select2({ placeholder: 'Lô tem', allowClear: true });
        }
        if ($('#warning_type').length) {
          $('#warning_type').select2({ placeholder: 'Loại cảnh báo', allowClear: true });
        }
      }, 50);
    });
  }

  ngOnInit() {
    $('#city_id').on('select2:select', function (e) {
      let city = e.params.data.id;
      that.listDistricts(city);
    });
    $('#city_id').on('select2:unselect', function (e) {
      that.list_district_by_city = [];
      $('#district_id').val('').trigger('change');
    });
    this.listCities();
    // this.listProducts();
    this.getListBatches();
    this.getOverView();
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.isSorting = 'desc';
      if (params.batch_id) {
        this.current_filter.batch_id = params.batch_id;
        $('#batch_id').val(params.batch_id).trigger('change');
        this.current_filter.response = params.response;
        $('#response').val(params.response.to).trigger('change');
        this.loadData(this.current_filter, this.isSorting);
      } else {
        this.loadData(this.current_filter, this.isSorting);
      }
    });
  }

  getOverView() {
    this.stampStatistic
      .getDashboardOverview()
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          this.overview = {
            verify_turn: res.data.verify_turn,
            stamps_verify: res.data.stamps_verify,
            warning_verify: res.data.warning_verify,
            warning_stamps: res.data.warning_stamps,
          };
        } else {
          console.log('getDashboardOverview:error', res);
        }
      })
      .catch((err: any) => {
        console.log('getDashboardOverview:catch', err);
      });
  }

  getListBatches() {
    let opt: any = {
      limit: 500,
    };
    this.batchService.getBatchesList(opt).subscribe((res) => {
      if (!res.error) {
        let batchs = res.data.batches;
        let listBatchs: any = [];
        for (let i = 0; i < batchs.length; i++) {
          let item = {
            value: batchs[i].id.toString(),
            label: batchs[i].name,
          };
          listBatchs.push(item);
        }
        this.listBatchs = listBatchs;
        setTimeout(() => {
          if ($('#warning_batch_id').length) {
            $('#warning_batch_id').select2({ placeholder: 'Lô tem', allowClear: true });
          }
        }, 50);
      }
    });
  }

  filterClick(type) {
    switch (type) {
      case 'verify_turn': {
        $('#product_id').val('').trigger('change');
        $('#response').val('').trigger('change');
        $('#type').val('').trigger('change');
        $('#city_id').val('').trigger('change');
        $('#district_id').val('').trigger('change');
        this.isSorting = 'desc';
        this.list_district_by_city = [];
        this.FormFilterLogsChongGia.reset();
        $('#response').val('active').trigger('change');
        this.onSubmit(this.FormFilterLogsChongGia);
        break;
      }
      case 'stamps_verify': {
        break;
      }
      case 'warning_verify': {
        $('#product_id').val('').trigger('change');
        $('#response').val('').trigger('change');
        $('#type').val('').trigger('change');
        $('#city_id').val('').trigger('change');
        $('#district_id').val('').trigger('change');
        this.isSorting = 'desc';
        this.list_district_by_city = [];
        this.FormFilterLogsChongGia.reset();
        $('#response').val('warning').trigger('change');
        this.onSubmit(this.FormFilterLogsChongGia);
        break;
      }
      case 'warning_stamps': {
        break;
      }
    }
  }

  public loadData(request: any = null, sort: any = {}) {
    this.waitPage = true;
    let data_get: any = request ? request : this.current_filter;
    if (this.currentPage < 0) {
      this.currentPage = 1;
    }
    data_get.offset =
      this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    data_get.limit = this.page_size;
    //data_get.sort_by = this.current_filter.sort_by;
    data_get.service = this.code_chonggia; // filter theo chống giả
    data_get.sort_by = 'ins_dt:' + sort;
    this.logsService
      .getLogsScan(data_get)
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          let list: any = [];
          for (let _data of res.data) {
            let type_f: string = '';
            if (_data.type == 'sms') {
              type_f = this.translate.instant('NHAN_TIN_SMS');
            } else if (_data.type == 'qrm') {
              type_f = this.translate.instant('QUET_MA_HO');
            } else if (_data.type == 'qri') {
              type_f = this.translate.instant('QUET_MA_PHU_CAO');
            } else {
              type_f = this.translate.instant('KHONG_XAC_DINH');
            }
            let response_f = '';
            if (_data.response == 'active') {
              response_f = this.translate.instant('XAC_THUC');
            } else if (_data.response == 'warning') {
              response_f = this.translate.instant('CANH_BAO');
            }
            let obj = {
              id: _data._id,
              serial: this.formatSerial(_data.number, _data.prefix),
              city: _data.city,
              type: _data.type,
              type_f: type_f,
              response: _data.response,
              response_f: response_f,
              scan_time: moment(_data.ins_dt).format('DD/MM/YYYY HH:mm:ss'),
              product_image: this.imageService.readSrcImage(
                _data.product_image,
                'thumb_medium'
              ),
              location_by: _data.location_by,
              location_type_batch: _data.location_type_batch,
            };
            list.push(obj);
          }
          // console.log(list);
          this.list_items = list;

          this.item_active = 0;
          if (list.length > 0) {
            this.has_list = true;
            this.viewDetail(0);
          } else {
            this.has_list = false;
            this.item_detail = null;
          }
        } else {
        }
        this.waitPage = false;
      })
      .catch((err: any) => {
      });
  }

  sliceSerial(serial) {
    let index = serial.indexOf('-');
    let prefix = serial.substring(0, index);
    let number = serial.substring(index + 1);
    let array = [];
    array.push(prefix, number)
    return array;
  }

  viewDetail(i) {
    this.item_active = i;

    console.log('asdasdasd', this.list_items[i]);
    let params = this.sliceSerial(this.list_items[i].serial);
    console.log('params', params);
    this.logsService
      .getLogsDetailLoyalty(this.list_items[i].id, params[0], params[1])
      .toPromise()
      .then((res: any) => {
        if (res.code === 1) {
          this.item_detail_loyalty = res.data;
          console.log('getLogsDetailLoyalty:succ:', this.item_detail_loyalty.campaign_name);
        } else {
          console.log('getLogsDetailLoyalty:error', res);
        }
      })
      .catch((err) => {
        console.log('getLogsDetailLoyalty:catch:', err);
      });

    this.logsService
      .getLogsDetail(this.list_items[i].id)
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          let arr_services = this.convertServiceToText(res.data.services);
          let diachi = '';
          if (res.data.address) {
            diachi += diachi ? ', ' + res.data.address : res.data.address;
          }
          if (res.data.district_name) {
            diachi += diachi ? ', ' + res.data.district : res.data.district;
          }
          this.item_detail = {
            id: res.data._id,
            serial: this.formatSerial(res.data.number, res.data.prefix),
            qrmMappingCode: res.data.qrmMappingCode,
            product_name: res.data.product_name,
            product_image: this.imageService.readSrcImage(
              res.data.product_image,
              'thumb_medium'
            ),
            code: res.data.code,
            type: res.data.type,
            type_f: this.list_items[i].type_f,
            batch_id: res.data.batch_id,
            batch_name: res.data.batch_name,
            arr_services: arr_services,
            active_time: res.data.active_time,
            active_time_f: moment(res.data.active_time).format('DD/MM/YYYY'),
            response: res.data.response,
            response_f: this.list_items[i].response_f,
            scanner: res.data.scanner,
            device_id: res.data.device_id,
            scan_time: moment(res.data.ins_dt).format('DD/MM/YYYY HH:mm:ss'),
            os: res.data.os,
            diachi: diachi,
            new_address: res.data.new_address,
            city: res.data.city,
            user_agent: res.data.user_agent,
            scan_by: res.data.scan_by,
            location_by: res.data.location_by,
            location_type_batch: res.data.location_type_batch,
          };
        } else {
          console.log('getLogsDetail:error', res);
        }
      })
      .catch((err) => {
        console.log('getLogsDetail:catch:', err);
      });
  }

  changeProduct(event) {
    this.productId = event ? event : null;
  }

  onSubmit(data?: any) {
    this.currentPage = 1;
    let data_filter: any = {};
    if ($('#response').val()) {
      data_filter.response = $('#response').val();
    }
    if (data.scan_time_ranger && data.scan_time_ranger.length == 2) {
      data_filter.from = moment(data.scan_time_ranger[0]).format('YYYY-MM-DD');
      data_filter.to = moment(data.scan_time_ranger[1]).format('YYYY-MM-DD');
    }
    if ($('#type').val()) {
      data_filter.type = $('#type').val();
    }
    if (data.serial) {
      data_filter.serial = data.serial;
    }
    if ($('#city_id').val()) {
      data_filter.city_id = $('#city_id').val();
    }
    if ($('#district_id').val()) {
      data_filter.district_id = $('#district_id').val();
    }
    // if ($("#product_id").val()) {
    //   data_filter.product_id = $("#product_id").val();
    // }
    if (this.productId) {
      data_filter.product_id = this.productId;
    }
    this.current_filter = data_filter;
    this.loadData(data_filter, this.isSorting);
  }

  ResetFormSearch() {
    $('#product_id').val('').trigger('change');
    $('#drp-list-product .clear').click();
    this.productId = null
    $('#response').val('').trigger('change');
    $('#type').val('').trigger('change');
    $('#city_id').val('').trigger('change');
    $('#district_id').val('').trigger('change');
    this.isSorting = 'desc';
    this.list_district_by_city = [];
    this.FormFilterLogsChongGia.reset();
    this.onSubmit(this.FormFilterLogsChongGia);
  }

  setSort(typeSort: string) {
    this.currentPage = 1;
    this.isSorting = typeSort;
    this.loadData(null, typeSort);
  }

  // listProducts() {
  //   this.productService
  //     .getProducts({ limit: 500, sort_by: "name:asc" })
  //     .toPromise()
  //     .then((res) => {
  //       if (res.error == false) {
  //         // let list:Array<IOption> = [];
  //         // for(let item of res.data.products){
  //         //     let obj = {value: item.id, label: item.name};
  //         //     list.push(obj);
  //         // }

  //         this.list_products = res.data.products.map((pro, index, products) => {
  //           return { value: pro.id, label: pro.name };
  //         });
  //       } else {
  //         console.log("getAllProduct: error", res);
  //       }
  //     })
  //     .catch((err: any) => {
  //       console.log("getAllProduct:catch", err);
  //     });
  // }

  listCities() {
    this.addressService
      .getCities()
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          let cities = {};
          let cities_filter: Array<IOption> = [];
          for (let city of res.data.cities) {
            cities_filter.push({ value: city.id, label: city.name });
            // cities[city.id] = city.name
          }
          // this.list_cities = cities;
          this.list_cities_filter = cities_filter;
        } else {
          console.log('getCities:error', res);
        }
      })
      .catch((err: any) => {
        console.log('getCities:catch', err);
      });
  }

  listDistricts(city_id) {
    if (city_id && city_id > 0) {
      this.addressService
        .getDistrict({ city_id: city_id })
        .toPromise()
        .then((res: any) => {
          if (res.error == false) {
            this.has_list_districts = true;
            let districts_filter: Array<IOption> = [];
            for (let district of res.data.districts) {
              districts_filter.push({
                value: district.id,
                label: district.name,
              });
            }
            this.list_district_by_city = districts_filter;
          } else {
            console.log('getDistrict:error', res);
          }
        })
        .catch((err: any) => {
          console.log('getDistrict:catch', err);
        });
    }
  }

  deselectedCity() {
    this.has_list_districts = false;
    this.list_district_by_city = [];
  }

  setPage(page: number) {
    if (page < 1) {
      this.currentPage = 1;
      return;
    }
    // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
    if (page !== this.currentPage) {
      this.currentPage = page;
      this.loadData(this.current_filter, this.isSorting);
    }
  }

  goPage(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    } else {
      this.setPage(1); //toPage = 1;
    }
  }

  convertServiceToText(service: string) {
    let arr_services: Array<{ code: number; name: string }> = [];
    if (service.indexOf(this.code_chonggia.toString()) != -1) {
      arr_services.push({ code: this.code_chonggia, name: this.translate.instant('CHONG_GIA') });
    }
    if (service.indexOf(this.code_baohanh.toString()) != -1) {
      arr_services.push({ code: this.code_baohanh, name: this.translate.instant('BAO_HANH') });
    }
    if (service.indexOf(this.code_tranhang.toString()) != -1) {
      arr_services.push({ code: this.code_tranhang, name: this.translate.instant('TRAN_HANG') });
    }
    if (service.indexOf(this.code_dinhdanh.toString()) != -1) {
      arr_services.push({ code: this.code_dinhdanh, name: this.translate.instant('DINH_DANH') });
    }
    return arr_services;
  }

  formatSerial(number, prefix: string = '') {
    let format_serial: string;
    let prefix2 = prefix ? prefix + '-' : '';
    number = number.toString();
    if (number.length > 6) {
      format_serial = prefix2 + number;
    } else {
      let pad = '000000';
      format_serial = prefix2 + pad.substring(0, 6 - number.length) + number;
    }
    return format_serial;
  }

  downloadExcel(data) {
    let data_filter: any = {};

    if ($('#response').val()) {
      data_filter.response = $('#response').val();
    }
    if (data.scan_time_ranger && data.scan_time_ranger.length == 2) {
      data_filter.from = moment(data.scan_time_ranger[0]).format('YYYY-MM-DD');
      data_filter.to = moment(data.scan_time_ranger[1]).format('YYYY-MM-DD');
    }
    if ($('#type').val()) {
      data_filter.type = $('#type').val();
    }
    if (data.serial) {
      data_filter.serial = data.serial;
    }
    if ($('#city_id').val()) {
      data_filter.city_id = $('#city_id').val();
    }
    if ($('#district_id').val()) {
      data_filter.district_id = $('#district_id').val();
    }
    if ($('#product_id').val()) {
      data_filter.product_id = $('#product_id').val();
    }
    this.current_filter = data_filter;
    var url = environment.api_evs + '/logs/scan/excel?';
    if ((data_filter.response = data.response)) {
      url += 'response=' + data_filter.response;
    }
    if (data_filter.from) {
      url += '&from=' + data_filter.from;
    }
    if (data_filter.to) {
      url += '&to=' + data_filter.to;
    }
    if (data_filter.type) {
      url += '&type=' + data_filter.type;
    }
    if (data_filter.serial) {
      url += '&serial=' + data_filter.serial;
    }
    if (data_filter.city_id) {
      url += '&city_id=' + data_filter.city_id;
    }
    if (data_filter.district_id) {
      url += '&district_id=' + data_filter.district_id;
    }

    url += '&sort_by=ins_dt:desc';
    if (localStorage.getItem('Access-Token')) {
      url += '&Access_Token=' + localStorage.getItem('Access-Token');
    }
    location.href = url;
  }

  /***Tuanba:17-11-2022: Thay api xuất báo cáo **/
  exportReport(data) {
    this.messageExport = '';
    $('.stampBoxStampAlertAdd').css('opacity', '0');
    const data_filter: any = {};
    if ($('#response').val()) {
      data_filter.response = $('#response').val();
    }
    if (data.scan_time_ranger && data.scan_time_ranger.length == 2) {
      data_filter.from = moment(data.scan_time_ranger[0]).format('YYYY-MM-DD');
      data_filter.to = moment(data.scan_time_ranger[1]).format('YYYY-MM-DD');
    }
    if ($('#type').val()) {
      data_filter.type = $('#type').val();
    }
    if (data.serial) {
      data_filter.serial = data.serial;
    }
    if ($('#city_id').val()) {
      data_filter.city_id = $('#city_id').val();
    }
    if (this.productId) {
      data_filter.product_id = this.productId;
    }
    data_filter.scan_service_type = null;
    data_filter.sort = `ins_dt,${this.isSorting}`;
    const body = {
      exportTypeEnum: 'SCAN_LOG_ANTICOUNTER_FEITING',
      fields: data_filter
    };
    this.exportService.exportReport(body).subscribe((res) => {
      if (res.code == 1) {
        this.messageExport = this.translate.instant('XUAT_FILE_THANH_CONG_VUI_LONG_KIEM_TRA_TRONG_QUAN_LY_BAO_CAO');
        $('.stampBoxStampAlertAdd').css('opacity', '1');
        setTimeout(() => {
          $('.stampBoxStampAlertAdd').css('opacity', '0');
        }, 5000);
      } else {
        $('.stampBoxStampAlertAdd').css('opacity', '0');
        this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    });
  }

  /*** Thêm popup api xuất báo cáo **/
  @ViewChild('validateDownloadExcelPopup') validateDownloadExcelPopup: ModalDirective;

  showPopupDownloadLogScan(data) {
    const data_filter: any = {};
    if (data.scan_time_ranger && data.scan_time_ranger.length == 2) {
      data_filter.fromDate = moment(data.scan_time_ranger[0]).format('DD-MM-YYYY');
      data_filter.toDate = moment(data.scan_time_ranger[1]).format('DD-MM-YYYY');
    }

    if (data_filter.fromDate && data_filter.toDate) {
      // Tính khoảng cách giữa from và to
      const fromDate = moment(data_filter.fromDate);
      const toDate = moment(data_filter.toDate);
      const diffInMonths = toDate.diff(fromDate, 'months', true); // true để tính chính xác đến ngày

      // Kiểm tra nếu khoảng cách lớn hơn 3 tháng
      if (diffInMonths > 3) {
        this.validateDownloadExcelPopup.show();
      } else {
        this.exportService.exportReportLogScan(data_filter).subscribe((res) => {
          if (res.code == 1) {
            this.messageExport = this.translate.instant('XUAT_FILE_THANH_CONG_VUI_LONG_KIEM_TRA_TRONG_QUAN_LY_BAO_CAO');
            $('.stampBoxStampAlertAdd').css('opacity', '1');
            setTimeout(() => {
              $('.stampBoxStampAlertAdd').css('opacity', '0');
            }, 5000);
          } else {
            $('.stampBoxStampAlertAdd').css('opacity', '0');
            this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            })
          }
        }, (error) => {
          this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          })
        });
      }
    } else {
      this.validateDownloadExcelPopup.show();
    }
  }

  closeModalValidateExport() {
    this.validateDownloadExcelPopup.hide();
  }

  getWarning() {
    let data: any = {};
    data.offset =
      this.warningPage_Size *
      (this.warningCurrentPage <= 0 ? 0 : this.warningCurrentPage - 1);
    data.limit = this.warningPage_Size;
    data.sort_by = 'ins_dt:desc';

    data.type = 4; // Cảnh báo chống giả

    if (this.warningFilter.serial) {
      data.serial = this.warningFilter.serial.trim();
    }
    let product_value2 = this.productId ? this.productId : null;
    if (product_value2) {
      data.product_id = product_value2;
    }
    let batch_id_value = $('#warning_batch_id').val();
    if (batch_id_value) {
      data.batch_id = batch_id_value;
    }
    let type_value = $('#warning_type').val();
    if (type_value) {
      data.type = type_value;
    }
    let store_value = $('#warning_store').val();
    if (store_value) {
      data.store_id = store_value;
    }
    let city_value = $('#warning_city').val();
    if (city_value) {
      data.city = city_value;
    }
    let district_value = $('#warning_district').val();
    if (district_value) {
      data.district = district_value;
    }
    if (this.warningFilter.time && this.warningFilter.time.length > 0) {
      data.from = moment(this.warningFilter.time[0]).format('YYYY-MM-DD');
      data.to = moment(this.warningFilter.time[1]).format('YYYY-MM-DD');
    }

    if (this.warningFilter.from) {
      data.active_from = moment(this.warningFilter.from[0]).format('YYYY-MM-DD');
      data.active_to = moment(this.warningFilter.from[1]).format('YYYY-MM-DD');
    }
    if (this.warningFilter.to) {
      data.dead_time_from = moment(this.warningFilter.to[0]).format('YYYY-MM-DD');
      data.dead_time_to = moment(this.warningFilter.to[1]).format('YYYY-MM-DD');
    }

    data.sort_scan_count = this.warningFilter.sort_scan_count;
    data.sort_people_count = this.warningFilter.sort_people_count;

    this.stampStatistic
      .getDashboardWarnings(data)
      .toPromise()
      .then((res: any) => {
        if (!res.error) {
          this.warningList = res.data.data;
          this.totalWarningPage = Math.ceil(res.data.count / this.warningPage_Size);
          this.totalWarningRow = res.data.total;
        } else {
          this.warningList = [];
        }
      })
      .catch((err: any) => {
        console.log('getDashboardWarnings:catch', err);
        this.warningList = [];
      });
  }

  filterWarning() {
    this.warningCurrentPage = 1;
    this.getWarning();
  }

  resetWarning() {
    this.warningFilter = {};
    this.productId = null;
    $('.value span').text(this.translate.instant('SAN_PHAM'));
    $('.clear').hide();
    $('#warning_batch_id').val(null).trigger('change');
    $('#warning_type').val(null).trigger('change');
    $('#warning_store').val(null).trigger('change');
    $('#warning_city').val(null).trigger('change');
    $('#warning_district').val(null).trigger('change');

    this.getWarning();
  }

  setWarningPage(page: number) {
    if (page <= this.totalWarningPage) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalWarningPage) {
        page = this.totalWarningPage;
      }
      if (page != this.warningCurrentPage) {
        this.warningCurrentPage = page;
        this.getWarning();
      }
    } else {
      page = this.totalWarningPage;
      if (page <= 0) {
        this.toastr.warning(this.translate.instant('KHONG_CO_DU_LIEU_CANH_BAO'), '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
        $('#inputWarning').val(1);
        this.warningCurrentPage = 1;
      } else {
        this.toastr.warning(
          this.translate.instant('SO_TRANG_CANH_BAO_TOI_DA_HIEN_TAI_LA') + ' ' + page,
          '',
          {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          }
        );
        if (page < 1) {
          page = 1;
        } else if (page > this.totalWarningPage) {
          page = this.totalWarningPage;
        }
        $('#inputWarning').val(page);
        if (page != this.warningCurrentPage) {
          this.warningCurrentPage = page;
          this.getWarning();
        }
      }
    }
  }

  sortScanCount(e: string) {
    if (e === this.warningFilter.sort_scan_count) {
      this.warningFilter.sort_scan_count = '';
    } else {
      this.warningFilter.sort_scan_count = e;
    }
    this.filterWarning();
  }

  sortPeopleCount(e: string) {
    if (e === this.warningFilter.sort_people_count) {
      this.warningFilter.sort_people_count = '';
    } else {
      this.warningFilter.sort_people_count = e;
    }
    this.filterWarning();
  }

  showReStore(item: any) {
    let detail = {
      name: item.batch.name,
      id: item.batch_id,
      id_start: item.number,
      id_end: item.number,
      prefix: item.prefix,
      readonly: true,
    };

    const initialState = { batch_detail: detail };
    this.modalRef = this.modalService.show(ModalCancelStampComponent, {
      initialState,
    });
    this.modalRef.content.closeBtnName = this.translate.instant('BO_QUA');
  }

  showLocation(warning, template) {
    if (warning.serial) {
      this.serialLocation = warning.serial;
      this.stampStatistic
        .getLocationSerialScan(warning.serial)
        .toPromise()
        .then((data) => {
          if (!data.error) {
            this.locationScan = data.data;
            if (this.locationScan.length > 0) {
              for (let i = 0; i < this.locationScan.length; i++) {
                this.locationScan[i].lat = parseFloat(this.locationScan[i].lat);
                this.locationScan[i].lon = parseFloat(this.locationScan[i].lon);
              }
              this.modalRefLocation = this.modalService.show(template);
            } else {
              this.toastr.warning(
                this.translate.instant('KHONG_CO_DU_LIEU_VI_TRI_QUET_CUA_SERIAL') + ' ' + warning.serial,
                '',
                {
                  timeOut: 3000,
                  positionClass: 'toast-bottom-right',
                }
              );
            }
          } else {
            this.toastr.error(data.error.message, '', {
              timeOut: 3000,
              positionClass: 'toast-bottom-right',
            });
          }
        })
        .catch((err) => {
          this.toastr.error(err.message, '', {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          });
        });
    }
  }

  exportWarningReport() {
    const [start, end] = this.warningFilter.time;
    const maxRange = moment(start).add(3, 'months');

    if (moment(end).isAfter(maxRange)) {
      this.messageExportWarning = this.translate.instant('CHI_DUOC_CHON_TOI_DA_TRONG_VONG_THANG');
      $('.stampBoxStampAlertAdd2').css('display', 'block');
      setTimeout(() => {
        $('.stampBoxStampAlertAdd2').css('display', 'none');
      }, 5000);
      return;
    }

    let data: any = {};
    data.offset =
      this.warningPage_Size *
      (this.warningCurrentPage <= 0 ? 0 : this.warningCurrentPage - 1);
    data.limit = this.warningPage_Size;
    data.sort_by = 'ins_dt:desc';
    data.type = 4;

    if (this.warningFilter.serial) {
      data.serial = this.warningFilter.serial.trim();
    }
    let product_value2 = this.productId ? this.productId : null;
    if (product_value2) {
      data.product_id = product_value2;
    }
    let batch_id_value = $('#warning_batch_id').val();
    if (batch_id_value) {
      data.batch_id = batch_id_value;
    }
    let type_value = $('#warning_type').val();
    if (type_value) {
      data.type = type_value;
    }
    let store_value = $('#warning_store').val();
    if (store_value) {
      data.store_id = store_value;
    }
    let city_value = $('#warning_city').val();
    if (city_value) {
      data.city = city_value;
    }
    let district_value = $('#warning_district').val();
    if (district_value) {
      data.district = district_value;
    }
    if (this.warningFilter.time && this.warningFilter.time.length > 0) {
      data.from = moment(this.warningFilter.time[0]).format('YYYY-MM-DD');
      data.to = moment(this.warningFilter.time[1]).format('YYYY-MM-DD');
    }

    if (this.warningFilter.from) {
      data.active_from = moment(this.warningFilter.from[0]).format('YYYY-MM-DD');
      data.active_to = moment(this.warningFilter.from[1]).format('YYYY-MM-DD');
    }
    if (this.warningFilter.to) {
      data.dead_time_from = moment(this.warningFilter.to[0]).format('YYYY-MM-DD');
      data.dead_time_to = moment(this.warningFilter.to[1]).format('YYYY-MM-DD');
    }
    data.sort_scan_count = this.warningFilter.sort_scan_count;
    data.sort_people_count = this.warningFilter.sort_people_count;
    var queryString = this.toQueryString(data);
    var url = environment.api_evs + '/dashboard/warning/excel?' + queryString;
    this.batchService.downloadExcelExample2(url).subscribe((res) => {
      saveAs(res, `Baocao.xlsx`);
    }, error => {
      this.toastr.warning(error.message, 'Thông báo', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    });
  }

  toQueryString(obj) {
    var str = [];
    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== null && obj[key] !== undefined) {
        str.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
      }
    }
    return str.join('&');
  }

  changeProduct2(event) {
    this.productId = event ? event : null;
  }

  changeProduct2Label(event) {
    $('.value span').text(event);
  }

  goWarningPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setWarningPage(toPage);
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/logs/log_scan.component.ts